<template>
  <div class="header-search">
    <div class="container header-container">
      <a class="logo" :href="siteUrl('')">
        <img class="page-logo" src="../../../img/kodobi-brand-logo.svg" width="124" height="41" alt="Логотип Kodobi">
      </a>
      <button class="header-burger" @click="toggleNavigation">
        <icon-base width="30" height="30"><icon-menu/></icon-base>
      </button>
      <div class="search">
        <input class="search-input" :placeholder="`${$t('Введите название магазина, например')}: velosite.ru, Ноу-хау, Lamoda`" @input="handleInput">
        <button class="button-primary search-button">
          <icon-base><icon-search/></icon-base>
        </button>
        <div class="search-results" v-if="shops.length">
          <a class="result-value" :href="shopUrl(shop.slug)" v-for="shop in shops" :key="shop.slug">
            <div class="result-logo">
              <img :src="shop.image" alt="">
            </div>
            <span class="result-name">{{ shop.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from '../IconBase.vue';
import IconSearch from '../icons/IconSearch.vue';
import IconMenu from '../icons/IconMenu.vue';

export default {
  name: 'app-header-search',

  components: {
    IconBase,
    IconSearch,
    IconMenu,
  },

  props: {},

  data() {
    return {
      xhr: null,
      shops: []
    };
  },

  methods: {
    toggleNavigation() {
      this.$emit('toggleNavigation');
    },

    handleInput(e) {
      const search = e.currentTarget.value;
      this.xhr.abort();
      clearTimeout(this._searchTimeout);
      if (search) {
        this._searchTimeout = setTimeout(() => {
          this.xhr.open('get', this.siteUrl(`api/shops/search/?query=${search}`));
          this.xhr.send();
          this.xhr.onload = (e) => {
            let json;
            try {
              json = JSON.parse(e.currentTarget.responseText);
            } catch (err) {
              console.log(err);
            }
            this.shops = json;
          }
        }, 250);
      } else {
        this.shops = [];
      }
    }
  },

  mounted() {
    this.xhr = new XMLHttpRequest();
  }
}
</script>

<style scoped>
.header-search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 100px;
  background-color: #ffffff;
}

.logo {
  width: 190px;
  min-width: 190px;
}

.logo img {
  margin-top: -14px;
}

.header-burger {
  display: none;
}

.search {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.search-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  min-width: 0;
  padding: 0 25px;
  font-size: 16px;
  color: #061332;
  border: 1px solid #a9abb4;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  background: #fff;
  height: 49px;
  z-index: 2;
}

.search-input::placeholder {
  color: #a9abb4;
}

.search-input:focus {
  border: 1px solid #3c91e6;
}

.search-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0;
  width: 70px;
  height: 49px;
  z-index: 2;
}

.search-results {
  z-index: 1;
  position: absolute;
  top: 47px;
  right: 70px;
  left: 0;
  background-color: #ffffff;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  max-height: 213px;
  overflow: auto;
}

.result-value {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #dbdce1;
}

.result-value:last-child {
  border-bottom: none;
}

.result-value:hover {
  color: #3c91e6;
}

.result-value:active {
  color: #29629c;
}

.result-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin: 0 20px 0 0;
  width: 160px;
  height: 50px;
}

.result-logo img {
  max-width: 100%;
  max-height: 100%;
}

.result-name {
  font-size: 16px;
}

@media (max-width: 1023px) {
  .logo {
    display: none;
  }

  .header-burger {
    display: block;
    margin: 0 20px 0 0;
    border: none;
    padding: 0;
    width: 30px;
    min-width: 30px;
    height: 30px;
    color: #dbdce1;
    background-color: transparent;
    cursor: pointer;
  }

  .header-burger:hover {
    color: #3c91e6;
  }

  .header-burger:active {
    color: #29629c;
  }
}

@media (max-width: 767px) {
  .header-burger {
    margin: 0 10px 0 0;
  }

  .header-search {
    min-height: 60px;
  }

  .header-search .header-container {
    padding: 5px 10px;
  }

  .search-input {
    padding: 0 15px;
    height: 41px;
  }

  .search-button {
    width: 50px;
    height: 41px;
  }

  .search-results {
    right: 50px;
    top: 38px;
    max-height: 120px;
  }

  .result-logo {
    display: none;
  }
}
</style>